import Footer from '@components/_rolex/Page/Footer'
import { Footer as GassanFooter, Header as GassanHeader } from '@components/Page'
import { FC, PropsWithChildren } from 'react'
import RCPOHeader from './Header'
import { RolexRCPOPageTypeTracking } from './PageTypeTracking'

type RCPOPageTypes =
  | 'home page'
  | 'selection page'
  | 'model page'
  | 'certification page'
  | 'programme page'
  | 'contact page'
  | 'store contact page'
  | 'contact form page'

export type RCPOPageProps = PropsWithChildren<{
  pageType: RCPOPageTypes
  productFamily?: string
  productRMC?: string
}>

export const RCPOPage: FC<RCPOPageProps> = ({ children, ...props }) => {
  return (
    <>
      <RolexRCPOPageTypeTracking {...props} />
      <GassanHeader initialVariant="absolute" />
      <div className="mx-auto max-w-[109rem]">
        <RCPOHeader />
        {children}
        <Footer variant="rcpo" />
      </div>
      <GassanFooter />
    </>
  )
}
